declare var window: {
    dataLayer: any[]
}

export function trackPage(
    page?: string,
) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'GAPageView',
            'page': page
        });
    }
}